import { RavenApp } from './app.js';

document.addEventListener('DOMContentLoaded', async () => {
    const app = new RavenApp();
    await app.init();
    window.ravenApp = app;
});
